import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { bffPost } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CustomerProductList } from './model';

export const useAddWishListItem = (
    wishListId = 'default',
): UseMutationResult<CustomerProductList, unknown, string> => {
    const auth = useAuthContext();
    const queryClient = useQueryClient();

    return useMutation<CustomerProductList, unknown, string>({
        mutationFn: async (productId: string) => {
            const { customer_id, access_token } = await auth.ready();

            return bffPost<CustomerProductList>(
                `/customers/${customer_id}/wish-lists/${wishListId}/products/${productId}`,
                {
                    accessToken: access_token,
                    customerId: customer_id,
                },
            );
        },
        onSuccess: (payload: CustomerProductList): void => {
            queryClient.setQueryData([BffQueryKey.CUSTOMER_WISH_LISTS], payload);
        },
    });
};
